// import { HttpClient, HttpParams } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';
// import { User } from 'src/app/digigov/dg_core/header/header.component';
// import { AuthenticationService } from 'src/app/digigov/services/authentication.service';

// @Injectable({
//   providedIn: 'root',
// })
// export class EmsServiceService {

 

  
//   // Dev
//   //  subjectId=50028831

//   // SIT
//   subjectId=50028131;

//   genderArray=[
//     {"genderId":21011,"description":"Male"},{"genderId":21012,"description":"Female"},
//     {"genderId":21013,"description":"Others"}
//   ]
//   constructor(private http: HttpClient) 
//   {
    
//   }

//   getEmpDetails(url): Observable<any> {
//     return this.http.get(url);
//   }

//   checkUniqueUserName(event): Observable<any> {
//     return this.http.post('/admin/unique-username', {
//       userName: event,
//     });
//   }

//   checkUniqueEmail(event, emsAllEmployee): Observable<any> {
//     return this.http.post('/admin/unique-email-id', {
//       emailID: event,
//       empId: emsAllEmployee.id ? emsAllEmployee.id : null,
//     });
//   }

//   checkUniqueMobile(event, emsAllEmployee): Observable<any> {
//     return this.http.post('/admin/unique-mobile-no', {
//       mobile_no: event,
//       empId: emsAllEmployee.id ? emsAllEmployee.id : null,
//     });
//   }

//   checkUniqueTelNo(event, emsAllEmployee): Observable<any> {
//     return this.http.post('/admin/unique-phone-no', {
//       phoneNumber: event,
//       empId: emsAllEmployee.id ? emsAllEmployee.id : null,
//     });
//   }

//   saveEmpDetails(jsonData): Observable<any> {
//     return this.http.post('/admin/employee-details', jsonData);
//   }

//   updateEmpDetails(jsonData): Observable<any> {
//     return this.http.put(`/admin/user-profiles`, jsonData,{params:new HttpParams().set('msgNotReq',true)});
//   }

//   getPayeeData(panNumber): Observable<any> {
//     let headers={"Content-Type":"text/plain",'Access-Control-Allow-Origin': '*'}
//     return this.http.get('^/payee-management/payee-search?panId=' + panNumber,{headers:headers});
//   }

//   getUserDetails() {
//     return this.http.get('/admin/user-login-dtls');
//   }

//   esign(obj,token) {
//     debugger
//     let authToken=token.token;
//     let headers={"Authorization":"Bearer "+authToken}
//     return this.http.post('~/generate-esign', obj,{headers:headers});
//   }
//   uploadTempDMS(obj) {
//     return this.http.post('/dms/file-upload', obj);
//   }
//   uploadPermDMS(obj) {
//     return this.http.put('/dms/to-filesystem', obj);
//   }
//   unlockUser(obj) {
//     return this.http.post('/security/unlock-user', obj);
//   }
//   resetPassword(obj) {
//     return this.http.put('/security/reset-password', obj);
//   }
//   empDetails(userName) {
//     return this.http.get('/security/user-details/' + userName);
//   }
//   generateOTP(obj) {
//     // let headers={"Authorization":"Bearer"+token}
//     debugger
//     return this.http.post('~/notification/send/message', obj);
//   }
 
//   validateOTP(id, otp,token) {
//     let headers={"Authorization":"Bearer"+token}
//     return this.http.get('~/notification/verify/otp/' + id + '/' + otp,{headers:headers});
//   }
//   createCase(obj) {
    
//     return this.http.post(`/case-mgmnt/cases`, obj);
//   }
//   generateToken()
//   {
//     return this.http.get(`/security/access-token`);
//   }

//   getAllDesignation()
//   {
//     let body=
//     {
//       "extendedVO": [
//         {
//           "attributeId": "string",
//           "attributeName": "string",
//           "attributeValue": "string",
//           "persist": true
//         }
//       ],
//       "customXidBean": {
//         "formatId": 0,
//         "gtrid": 0,
//         "bqual": 0
//       },
//       "dbSchema": 0,
//       "dsgnId": 0,
//       "dsgnName": "string",
//       "dsgnShrtName": "string",
//       "levelId": 0,
//       "levelName": "string",
//       "langId": 0,
//       "crtPost": 0,
//       "locId": 0,
//       "dsgnLanguagesIdEntry": "string",
//       "dsgnLanguagesNameEntry": "string"
//     }
//     return this.http.post(`/admin/user-designation-all`,body)
//   }

//   checkAdditionalParams(paramName,paramValue)
//   {
//     let obj=
//     {
//       "key" : paramName,
//       "value" :paramValue 
//     }
//     return this.http.post(`/admin/unique-addl-param`,obj,{params:new HttpParams().set('tokenRequired',true)})
//   }
  
//    getBuildDetails()
//     {
//       return this.http.get(`+/GlobalMasterList/masterlist-management/getBuildReport`);
//     }
// }
// ==============================================================================================================
// Before CDAC 
// ==============================================================================================================
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmsServiceService {

  // Dev
  // subjectId=50028831

  // SIT
   subjectId=50028131;

  financeDeptId;
  cdacAllowed=true;

  genderArray=[
    {"genderId":21011,"description":"Male"},{"genderId":21012,"description":"Female"},
    {"genderId":21013,"description":"Others"}
  ]
  constructor(private http: HttpClient) {}

  getEmpDetails(url): Observable<any> {
    return this.http.get(url);
  }

  checkUniqueUserName(event): Observable<any> {
    return this.http.post('/admin/unique-username', {
      userName: event,
    });
  }

  checkUniqueEmail(event, emsAllEmployee): Observable<any> {
    return this.http.post('/admin/unique-email-id', {
      emailID: event,
      empId: emsAllEmployee.id ? emsAllEmployee.id : null,
    });
  }

  checkUniqueMobile(event, emsAllEmployee): Observable<any> {
    return this.http.post('/admin/unique-mobile-no', {
      mobile_no: event,
      empId: emsAllEmployee.id ? emsAllEmployee.id : null,
    });
  }

  checkUniqueTelNo(event, emsAllEmployee): Observable<any> {
    return this.http.post('/admin/unique-phone-no', {
      phoneNumber: event,
      empId: emsAllEmployee.id ? emsAllEmployee.id : null,
    });
  }

  saveEmpDetails(jsonData): Observable<any> {
    return this.http.post('/admin/employee-details', jsonData,
    // {params:new HttpParams().set('msgNotReq',true)}
    );
  }

  updateEmpDetails(jsonData): Observable<any> {
    return this.http.put(`/admin/user-profiles`, jsonData,
    // {params:new HttpParams().set('msgNotReq',true)}
    );
  }

  getPayeeData(panNumber): Observable<any> {
    let headers={"Content-Type":"text/plain",'Access-Control-Allow-Origin': '*'}
    return this.http.get('^/payee-management/v1/payee-search?panId=' + panNumber,{headers:headers});
  }

  getUserDetails() {
    return this.http.get('/admin/user-login-dtls');
  }

  esign(obj,token) {
    debugger
    let authToken=token.token;
    let headers={"Authorization":"Bearer "+authToken}
    return this.http.post('~/signer/v1/sign/content', obj,{headers:headers});
  }
  uploadTempDMS(obj) {
    return this.http.post('/dms/file-upload', obj);
  }
  uploadPermDMS(obj) {
    return this.http.put('/dms/to-filesystem', obj);
  }
  unlockUser(obj) {
    return this.http.post('/security/unlock-user', obj);
  }
  resetPassword(obj) {
    return this.http.put('/security/reset-password', obj);
  }
  empDetails(userName) {
    return this.http.get('/security/user-details/' + userName);
  }
  generateOTP(obj) {
    // let headers={"Authorization":"Bearer"+token}
    debugger
    return this.http.post('~/notification/send/message', obj)
  }
 
  validateOTP(id, otp,token) {
    let headers={"Authorization":"Bearer"+token}
    return this.http.get('~/notification/verify/otp/' + id + '/' + otp,{headers:headers});
  }
  createCase(obj) {
    
    return this.http.post(`/case-mgmnt/cases`, obj
    // ,{params:new HttpParams().set('msgNotReq',true)}
    
    );
  }
  generateToken()
  {
    return this.http.get(`/security/access-token`);
  }

  getAllDesignation()
  {
    let body=
    {
      "extendedVO": [
        {
          "attributeId": "string",
          "attributeName": "string",
          "attributeValue": "string",
          "persist": true
        }
      ],
      "customXidBean": {
        "formatId": 0,
        "gtrid": 0,
        "bqual": 0
      },
      "dbSchema": 0,
      "dsgnId": 0,
      "dsgnName": "string",
      "dsgnShrtName": "string",
      "levelId": 0,
      "levelName": "string",
      "langId": 0,
      "crtPost": 0,
      "locId": 0,
      "dsgnLanguagesIdEntry": "string",
      "dsgnLanguagesNameEntry": "string"
    }
    return this.http.post(`/admin/user-designation-all`,body)
  }

  checkAdditionalParams(paramName,paramValue)
  {
    let obj=
    {
      "key" : paramName,
      "value" :paramValue 
    }
    return this.http.post(`/admin/unique-addl-param`,obj)}


    getBuildDetails()
    {
      return this.http.get(`+/GlobalMasterList/v1/masterlist-management/getBuildReport`);
    }

    getAllEmployees(body)
    {
      let url=`/admin/all-employee-details`;
      this.http.post(url,body);
    }

    esignCDAC(payload)
    {
      let url=`~/generate-esign`;
      return this.http.post(url,payload)
    }

    getDynamicOfficeID()
    {
      let url=`/admin/organization-details?key=officeid&value=800003`;
      return this.http.get(url);
    }

    testForEsign(esignId,officeId,userId,roleId)
    {
      let url=`~/get-esign-status?esignId=${esignId}&userId=${userId}&roleId=${roleId}&officeId=${officeId}`;
      return this.http.get(url);
    }
}
